import type { RequestResponse } from '@/types/publicType'
import type {
  giftInterface,
  giftAjaxInterface,
  giftSendRequestInterface,
  giftSendResponseInterface
} from '@/types/apiType/giftType'

/**
 * 获取礼物列表，用户列表列表
 * @param {string} appVersion 版本号
 * @param {number} giftScreen 传0
 * @param {number} giftVersion 礼物版本号
 */
export function apiGetGiftList(params: {
  appVersion: ''
  giftScreen: number
  giftVersion: number
}): Promise<RequestResponse<giftAjaxInterface>> {
  return getFetchData({
    url: '/h5/gift/listV3',
    method: 'GET',
    params
  })
}

/**
 * 背包礼物
 * @param {string} app 传olamet
 * @param {string} appVersion  版本号 ''
 * @param {number} giftVersion 礼物版本号
 * @param {number} os 传web
 * @param {number} sn 传''
 */
export function apiGetGiftListPackage(params: {
  app: string
  appVersion: ''
  giftVersion: number
  os: 'web'
  sn: ''
}): Promise<RequestResponse<giftInterface[]>> {
  return getFetchData({
    url: '/h5/gift/listPackage',
    method: 'GET',
    params
  })
}

/**
 * 单人送礼接口
 * @param {string} appVersion 版本号 ''
 * @param {number} comboCount 0
 * @param {number} comboFrequencyCount 0
 * @param {number} comboId 0
 * @param {string} os 'web'
 * @param {string} sn ''
 * @param {string} expressMessage '表白礼物留言'
 * @param {number} giftId '赠送的礼物ID'
 * @param {number} giftNum '赠送的礼物数量'
 * @param {number} momentId '动态id'
 * @param {number} roomType '用户所在房间类型 -1:'',3:语音房,5:'',6:视频房,7:游戏房,8：多人视频房,10:1v1视频聊天'
 * @param {number} roomUid '用户所在房间UID'
 * @param {number} roomId '用户所在房间ID'
 * @param {number} targetUid '收礼用户ID'
 * @param {number} type '赠送礼物类型：1，赠送给房主；2，私聊发礼物；3，房间内赠送给个人；6，动态送礼 7，主播送礼'
 */
export function apiGiftSend(
  data: giftSendRequestInterface
): Promise<RequestResponse<giftSendResponseInterface>> {
  return getFetchData({
    url: '/h5/gift/send',
    method: 'POST',
    data,
    isCloseTost: true
  })
}

/**
 * 多人送礼接口
 * @param {string} appVersion 版本号 ''
 * @param {number} comboCount 0
 * @param {number} comboFrequencyCount 0
 * @param {number} comboId 0
 * @param {string} os 'web'
 * @param {string} sn ''
 * @param {number} giftId '赠送的礼物ID'
 * @param {number} giftNum '赠送的礼物数量'
 * @param {number} roomType '用户所在房间类型 -1:'',3:语音房,5:'',6:视频房,7:游戏房,8：多人视频房,10:1v1视频聊天'
 * @param {number} roomUid '用户所在房间UID'
 * @param {number} roomId '用户所在房间ID'
 * @param {string} targetUids '收礼用户ID'
 */
export function apiGiftSendMulti(
  data: giftSendRequestInterface
): Promise<RequestResponse<giftSendResponseInterface>> {
  return getFetchData({
    url: '/h5/gift/sendWholeMicroV4',
    method: 'POST',
    data,
    isCloseTost: true
  })
}
